var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "nav-bar-container" }, [
        _c("div", { staticClass: "nav-bar" }, [
          _c("div", [
            _vm.isNewUser
              ? _c("span", { staticClass: "nav-header" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$i18n.t(
                          "settings.password.createPassword.welcomePrefix"
                        )
                      ) +
                      "\n        "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("span", { staticClass: "nav-name" }, [
              _vm._v(_vm._s(_vm.userName)),
            ]),
            _vm._v(" "),
            _vm.isNewUser
              ? _c("span", { staticClass: "nav-header" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$i18n.t("settings.password.createPassword.comma")
                    )
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.isNewUser
            ? _c("span", { staticClass: "nav-header" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$i18n.t("settings.password.createPassword.welcome")
                    ) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showBackButton()
            ? _c(
                "a",
                {
                  on: {
                    click: function ($event) {
                      return _vm.navBack()
                    },
                  },
                },
                [_vm._v("\n        < " + _vm._s(_vm.$i18n.t("back")))]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "reset-container" }, [
        _c("div", { staticClass: "header" }, [
          _vm.isNewUser
            ? _c("span", { staticClass: "notice-header" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$i18n.t(
                        "settings.password.createPassword.proceedHead"
                      )
                    ) +
                    "\n      "
                ),
              ])
            : _c("span", { staticClass: "notice-header" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$i18n.t(
                        "settings.password.forgotPassword.proceedHead"
                      )
                    ) +
                    "\n      "
                ),
              ]),
          _vm._v(" "),
          _c("hr", { staticStyle: { "max-width": "100%", width: "100%" } }),
        ]),
        _vm._v(" "),
        _c(
          "form",
          {
            staticClass: "reset-pwd-form",
            attrs: { "data-abide": "", novalidate: "", id: "confirm-pwd-form" },
            on: {
              submit: function ($event) {
                $event.preventDefault()
              },
            },
          },
          [
            _c("label", { staticClass: "required-flag" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("settings.password.newPassword")) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "password-input-container" }, [
              (_vm.isNewPasswordVisible ? "text" : "password") === "checkbox"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.newPassword,
                        expression: "newPassword",
                      },
                    ],
                    staticClass: "text-input password-input",
                    attrs: { required: "", type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.newPassword)
                        ? _vm._i(_vm.newPassword, null) > -1
                        : _vm.newPassword,
                    },
                    on: {
                      focus: function ($event) {
                        _vm.showPasswordHint = true
                      },
                      blur: function ($event) {
                        _vm.showPasswordHint = false
                      },
                      change: function ($event) {
                        var $$a = _vm.newPassword,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.newPassword = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.newPassword = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.newPassword = $$c
                        }
                      },
                    },
                  })
                : (_vm.isNewPasswordVisible ? "text" : "password") === "radio"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.newPassword,
                        expression: "newPassword",
                      },
                    ],
                    staticClass: "text-input password-input",
                    attrs: { required: "", type: "radio" },
                    domProps: { checked: _vm._q(_vm.newPassword, null) },
                    on: {
                      focus: function ($event) {
                        _vm.showPasswordHint = true
                      },
                      blur: function ($event) {
                        _vm.showPasswordHint = false
                      },
                      change: function ($event) {
                        _vm.newPassword = null
                      },
                    },
                  })
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.newPassword,
                        expression: "newPassword",
                      },
                    ],
                    staticClass: "text-input password-input",
                    attrs: {
                      required: "",
                      type: _vm.isNewPasswordVisible ? "text" : "password",
                    },
                    domProps: { value: _vm.newPassword },
                    on: {
                      focus: function ($event) {
                        _vm.showPasswordHint = true
                      },
                      blur: function ($event) {
                        _vm.showPasswordHint = false
                      },
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.newPassword = $event.target.value
                      },
                    },
                  }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "password-visibility-toggle",
                  attrs: {
                    type: "button",
                    "aria-label": _vm.isNewPasswordVisible
                      ? "Hide new password"
                      : "Show new password",
                    "aria-pressed": _vm.isNewPasswordVisible.toString(),
                    title: _vm.isNewPasswordVisible
                      ? "Hide new password"
                      : "Show new password",
                  },
                  on: { click: _vm.toggleNewPasswordVisibility },
                },
                [
                  _vm.isNewPasswordVisible
                    ? _c(
                        "svg",
                        {
                          staticClass: "password-visibility-icon",
                          attrs: {
                            "aria-hidden": "true",
                            width: "40",
                            height: "38",
                            viewBox: "0 0 40 38",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M10 19.4179C10 19.4179 13.5496 13.4151 20 13.4151C26.4504 13.4151 30 19.4179 30 19.4179",
                              stroke: "#0B3A59",
                              "stroke-width": "1.6",
                              "stroke-linejoin": "round",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M23.5837 19.4179C23.5837 21.3899 21.9793 22.9884 20 22.9884",
                              stroke: "#0B3A59",
                              "stroke-width": "1.6",
                              "stroke-linejoin": "round",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M17.368 21.8435C16.776 21.2066 16.4141 20.3543 16.4141 19.4179C16.4141 17.4459 18.0185 15.8473 19.9977 15.8473C20.87 15.8473 21.6692 16.1578 22.2907 16.6739",
                              stroke: "#0B3A59",
                              "stroke-width": "1.6",
                              "stroke-linejoin": "round",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M27.5473 12.3351L13.2812 25.6649",
                              stroke: "#0B3A59",
                              "stroke-width": "1.6",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      )
                    : _c(
                        "svg",
                        {
                          staticClass: "password-visibility-icon",
                          attrs: {
                            "aria-hidden": "true",
                            width: "40",
                            height: "38",
                            viewBox: "0 0 40 38",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M10 19.4768C10 19.4768 13.5496 13.4737 20 13.4737C26.4504 13.4737 30 19.4765 30 19.4765",
                              stroke: "#0B3A59",
                              "stroke-width": "1.6",
                              "stroke-linejoin": "round",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M22.5357 22.0015C23.9352 20.6071 23.9352 18.3464 22.5357 16.952C21.1362 15.5576 18.8672 15.5576 17.4676 16.952C16.0681 18.3464 16.0681 20.6071 17.4676 22.0015C18.8672 23.3959 21.1362 23.3959 22.5357 22.0015Z",
                              stroke: "#0B3A59",
                              "stroke-width": "1.6",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showPasswordHint,
                    expression: "showPasswordHint",
                  },
                ],
                staticClass: "pwd-hint-span",
              },
              [_vm._v(_vm._s(_vm.$i18n.t("settings.password.rule")))]
            ),
            _vm._v(" "),
            _c("label", { staticClass: "required-flag" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("settings.password.confirmPassword")) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "password-input-container" }, [
              (_vm.isConfirmPasswordVisible ? "text" : "password") ===
              "checkbox"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.confirmPassword,
                        expression: "confirmPassword",
                      },
                    ],
                    staticClass: "text-input password-input",
                    attrs: { required: "", type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.confirmPassword)
                        ? _vm._i(_vm.confirmPassword, null) > -1
                        : _vm.confirmPassword,
                    },
                    on: {
                      focus: function ($event) {
                        _vm.finishInput = false
                      },
                      blur: function ($event) {
                        _vm.finishInput = true
                      },
                      change: function ($event) {
                        var $$a = _vm.confirmPassword,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.confirmPassword = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.confirmPassword = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.confirmPassword = $$c
                        }
                      },
                    },
                  })
                : (_vm.isConfirmPasswordVisible ? "text" : "password") ===
                  "radio"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.confirmPassword,
                        expression: "confirmPassword",
                      },
                    ],
                    staticClass: "text-input password-input",
                    attrs: { required: "", type: "radio" },
                    domProps: { checked: _vm._q(_vm.confirmPassword, null) },
                    on: {
                      focus: function ($event) {
                        _vm.finishInput = false
                      },
                      blur: function ($event) {
                        _vm.finishInput = true
                      },
                      change: function ($event) {
                        _vm.confirmPassword = null
                      },
                    },
                  })
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.confirmPassword,
                        expression: "confirmPassword",
                      },
                    ],
                    staticClass: "text-input password-input",
                    attrs: {
                      required: "",
                      type: _vm.isConfirmPasswordVisible ? "text" : "password",
                    },
                    domProps: { value: _vm.confirmPassword },
                    on: {
                      focus: function ($event) {
                        _vm.finishInput = false
                      },
                      blur: function ($event) {
                        _vm.finishInput = true
                      },
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.confirmPassword = $event.target.value
                      },
                    },
                  }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "password-visibility-toggle",
                  attrs: {
                    type: "button",
                    "aria-label": _vm.isConfirmPasswordVisible
                      ? "Hide confirm password"
                      : "Show confirm password",
                    "aria-pressed": _vm.isConfirmPasswordVisible.toString(),
                    title: _vm.isConfirmPasswordVisible
                      ? "Hide confirm password"
                      : "Show confirm password",
                  },
                  on: { click: _vm.toggleConfirmPasswordVisibility },
                },
                [
                  _vm.isConfirmPasswordVisible
                    ? _c(
                        "svg",
                        {
                          staticClass: "password-visibility-icon",
                          attrs: {
                            "aria-hidden": "true",
                            width: "40",
                            height: "38",
                            viewBox: "0 0 40 38",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M10 19.4179C10 19.4179 13.5496 13.4151 20 13.4151C26.4504 13.4151 30 19.4179 30 19.4179",
                              stroke: "#0B3A59",
                              "stroke-width": "1.6",
                              "stroke-linejoin": "round",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M23.5837 19.4179C23.5837 21.3899 21.9793 22.9884 20 22.9884",
                              stroke: "#0B3A59",
                              "stroke-width": "1.6",
                              "stroke-linejoin": "round",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M17.368 21.8435C16.776 21.2066 16.4141 20.3543 16.4141 19.4179C16.4141 17.4459 18.0185 15.8473 19.9977 15.8473C20.87 15.8473 21.6692 16.1578 22.2907 16.6739",
                              stroke: "#0B3A59",
                              "stroke-width": "1.6",
                              "stroke-linejoin": "round",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M27.5473 12.3351L13.2812 25.6649",
                              stroke: "#0B3A59",
                              "stroke-width": "1.6",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      )
                    : _c(
                        "svg",
                        {
                          staticClass: "password-visibility-icon",
                          attrs: {
                            "aria-hidden": "true",
                            width: "40",
                            height: "38",
                            viewBox: "0 0 40 38",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M10 19.4768C10 19.4768 13.5496 13.4737 20 13.4737C26.4504 13.4737 30 19.4765 30 19.4765",
                              stroke: "#0B3A59",
                              "stroke-width": "1.6",
                              "stroke-linejoin": "round",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M22.5357 22.0015C23.9352 20.6071 23.9352 18.3464 22.5357 16.952C21.1362 15.5576 18.8672 15.5576 17.4676 16.952C16.0681 18.3464 16.0681 20.6071 17.4676 22.0015C18.8672 23.3959 21.1362 23.3959 22.5357 22.0015Z",
                              stroke: "#0B3A59",
                              "stroke-width": "1.6",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      !_vm.validForm && _vm.confirmPassword && _vm.finishInput,
                    expression: "!validForm&&confirmPassword&&finishInput",
                  },
                ],
                staticClass: "pwd-error-span",
              },
              [_vm._v(_vm._s(_vm.$i18n.t("settings.password.errorHint")))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "btns-set" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn--orange  radius round",
                  attrs: {
                    type: "submit",
                    id: "forgotpwd-form-send",
                    disabled: !_vm.validForm,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.send()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$i18n.t("action.confirm")))]
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "resetExceptionModal",
          attrs: { modalId: "reset-exception-modal" },
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("pre", { staticClass: "modal-pure-text" }, [
              _vm._v(
                _vm._s(_vm.errMsg || _vm.$t("settings.password.cannotReset"))
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                on: {
                  click: function ($event) {
                    return _vm.resetExceptionModal.close()
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("action.ok")) + "\n      ")]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "confirmResetPwdModal",
          attrs: { modalId: "confirm-reset-pwd-modal" },
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("pre", { staticClass: "modal-pure-text" }, [
              _vm._v(_vm._s(_vm.$t("settings.password.passwordChangeSuccess"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                on: {
                  click: function ($event) {
                    return _vm.navToLogin()
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("action.ok")) + "\n      ")]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }